export const QueryParameterNames = {
	ReturnUrl: 'returnUrl',
	Message: 'message'
};

export const LoginPath = ['account', 'login'];
export const LoggedOutPath = ['account', 'logged-out'];

export const ApplicationPaths = {
	LogOut: 'authentication/logout',
	LoginPathComponents: ['account', 'login'],
	LoggedOutPathComponents: ['account', 'logged-out'],
};
